<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        Danh sách doanh nghiệp
        <span>{{ mData.isApproved ? "đã duyệt" : "chờ duyệt" }}</span>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <el-row :gutter="15">
                  <el-col :span="12">
                    <el-form-item label="Công ty">
                      <el-autocomplete
                        v-model="mData.tenCongTy"
                        :fetch-suggestions="querySearchCongTy"
                        placeholder="Nhập tên Công ty"
                        @select="handleSelectForSearchCongTy"
                        @clear="clearInputSearch('cong_ty_lu_hanh_id')"
                        style="width: 100%"
                      >
                        <template slot-scope="{ item }">
                          <span>{{ item.ten.vi }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Số giấy phép">
                      <el-autocomplete
                        v-model="mData.soGiayPhepKinhDoanh"
                        :fetch-suggestions="querySearchSoGiayPhep"
                        placeholder="Nhập số giấy phép"
                        @select="handleSelectForSearchSoGiayPhep"
                        @clear="clearInputSearch('cong_ty_lu_hanh_id')"
                        style="width: 100%"
                      >
                        <template slot-scope="{ item }">
                          <span>{{
                            item.giay_phep_kinh_doanh.so_giay_phep
                          }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="Số điện thoại">
                      <el-autocomplete
                        v-model="mData.soDienThoai"
                        :fetch-suggestions="querySearchSoDienThoai"
                        placeholder="Nhập số điện thoại"
                        @select="handleSelectForSearchSoDienThoai"
                        @clear="clearInputSearch('cong_ty_lu_hanh_id')"
                        style="width: 100%"
                      >
                        <template slot-scope="{ item }">
                          <span>{{ item.dien_thoai }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="Email">
                      <el-autocomplete
                        v-model="mData.email"
                        :fetch-suggestions="querySearchEmail"
                        placeholder="Nhập email"
                        @select="handleSelectForSearchEmail"
                        @clear="clearInputSearch('cong_ty_lu_hanh_id')"
                        style="width: 100%"
                      >
                        <template slot-scope="{ item }">
                          <span>{{ item.email }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Ngày đăng ký">
                      <el-date-picker
                        v-model="
                          mData.tableRules.dataSearch.value['created_time']
                        "
                        type="daterange"
                        range-separator="-"
                        start-placeholder="Từ ngày"
                        end-placeholder="Đến ngày"
                        style="width: 100%"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >Tìm kiếm</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col :class="'col-md-8'">
            <div class="text-left mb-0"></div>
          </b-col>
          <b-col :class="'col-md-4'">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain
                >Ẩn/hiện tìm kiếm</el-button
              >
            </div>
          </b-col>
        </b-row>
        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }"
        >
          <el-table-column label="STT" width="50">
            <template slot-scope="scope">
              <div class="text-center">
                {{ mData.tableRules.offset + scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Tên công ty"
            min-width="300"
            prop="ten_cong_ty"
          />
          <el-table-column
            label="Giấy phép kinh doanh"
            min-width="200"
            prop="so_giay_phep_kinh_doanh"
          />
          <el-table-column
            label="Điện thoại"
            min-width="100"
            prop="dien_thoai"
          />
          <el-table-column label="Email" min-width="170" prop="email" />
          <el-table-column label="Website" min-width="170" prop="website" />
          <el-table-column label="Địa chỉ" min-width="170" prop="dia_chi" />
          <el-table-column
            label="Ngày đăng ký"
            width="140"
            prop="created_time"
          />

          <el-table-column label="Thao tác" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('tu_choi', scope.$index, scope.row)"
                v-b-popover.hover.left="'Từ chối'"
                v-if="!mData.isApproved"
                type="danger"
                plain
              >
                <i class="fa fa-ban"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('duyet', scope.$index, scope.row)"
                v-b-popover.hover.left="'Duyệt'"
                v-if="!mData.isApproved"
                type="success"
                plain
              >
                <i class="fa fa-check"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('bo_duyet', scope.$index, scope.row)"
                v-b-popover.hover.left="'Bỏ duyệt'"
                v-if="mData.isApproved"
                type="warning"
                plain
              >
                <i class="fa fa-eject"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="'Chi tiết'"
              >
                <i class="fa fa-eye"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="mt-2 text-right">
          <el-pagination
            @size-change="fn_tableSizeChange"
            @current-change="fn_tableCurentChange"
            @prev-click="fn_tablePrevClick"
            @next-click="fn_tableNextClick"
            :page-sizes="mData.tableRules.lengthMenu"
            :page-size="mData.tableRules.limit"
            :current-page="mData.tableRules.page"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="mData.tableRules.total"
            :pager-count="5"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MethodService from "@/service/MethodService";
import mushroom from "@/service/mushroom.api.def";
import DangKyChuongTrinhModel from "./DangKyChuongTrinhKichCauModel";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      mData: {
        isApproved: false,
        moduleName: "DangKyChuongTrinhKichCau",
        tenCongTy: "",
        soGiayPhepKinhDoanh: "",
        email: "",
        soDienThoai: "",
        tableRules: MethodService.copyObject(DangKyChuongTrinhModel.tableRules),
      },
    };
  },

  methods: {
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
    fn_handle(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name:
            this.$route.name === "Admin-DangKyChuongTrinhKichCau-DaDuyet-list"
              ? "Admin-DangKyChuongTrinhKichCau-approved"
              : "Admin-DangKyChuongTrinhKichCau-pending",
          params: { id: row.cong_ty_lu_hanh_id },
        });
        localStorage.setItem("dang_ky_chuong_trinh_id", row.id);
      } else this.fn_Action(type, row.id);
    },
    fn_Action(type, id) {
      Swal.fire({
        title: "THÔNG BÁO",
        text:
          type == "duyet"
            ? "Doanh nghiệp đăng ký chương trình sẽ được duyệt"
            : type == "bo_duyet"
            ? "Doanh nghiệp đăng ký chương trình sẽ bỏ duyệt"
            : "Từ chối doanh nghiệp đăng ký chương trình",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText:
          type == "duyet"
            ? "Duyệt"
            : type == "bo_duyet"
            ? "Bỏ duyệt"
            : "Từ chối",
        cancelButtonText: "Hủy",
      }).then((result) => {
        if (result.isConfirmed) {
          if (type == "tu_choi") this.fn_tuChoiDangKyChuongTrinh(id);
          else if (type == "bo_duyet") this.fn_boDuyetDangKyChuongTrinh(id);
          else this.fn_duyetDangKyChuongTrinh(id);
        }
      });
    },
    async fn_tuChoiDangKyChuongTrinh(id) {
      try {
        const response = await mushroom.dang_ky_chuong_trinh.deleteAsync({
          id: id,
        });
        if (response.result === 1) {
          await this.getListDanhSachCongTy();
          toastr.success("Từ chối đăng ký chương trình thành công");
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
        toastr.error("Đã có lỗi xảy ra. Vui lòng kiểm tra lại!");
      }
    },
    async fn_duyetDangKyChuongTrinh(id) {
      try {
        const response = await mushroom.dang_ky_chuong_trinh.approveAsync({
          id: id,
        });
        if (response) {
          await this.getListDanhSachCongTy();
          toastr.success("Duyệt đăng ký chương trình thành công");
        }
      } catch (error) {
        console.error("Có lỗi: %o", error);
        toastr.error("Đã có lỗi xảy ra. Vui lòng kiểm tra lại!");
      }
    },
    async fn_boDuyetDangKyChuongTrinh(id) {
      try {
        const response = await mushroom.dang_ky_chuong_trinh.rejectAsync({
          id: id,
        });
        if (response) {
          await this.getListDanhSachCongTy();
          toastr.success("Bỏ duyệt đăng ký chương trình thành công");
        }
      } catch (error) {
        console.error("Có lỗi: %o", error);
      }
    },
    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.getAmThucList();
    },
    fn_tableSearch() {
      if (
        !this.mData.tenCongTy &&
        !this.mData.email &&
        !this.mData.soDienThoai &&
        !this.mData.soGiayPhepKinhDoanh &&
        !this.mData.tableRules.dataSearch.value["created_time"]
      )
        this.mData.tableRules.dataSearch.value["cong_ty_lu_hanh_id"] = "";
      this.mData.tableRules.filters = MethodService.filterTable(
        JSON.stringify(this.mData.tableRules.dataSearch)
      );
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.sort = "";
      this.getListDanhSachCongTy();
    },
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getAmThucList();
    },
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name:
          "Admin-DangKyChuongTrinhKichCau" +
          (this.mData.isApproved ? "-DaDuyet-list" : "-ChoDuyet-list"),
        query: query,
      });
    },

    // Tìm kiếm công ty async
    async querySearchCongTyAsync(queryString, type) {
    if(!queryString || queryString.trim() === '') return [];
      let dataFilter = {
        fields: "id,isDisabled,ten,giay_phep_kinh_doanh,email,dien_thoai",
        limit: 10,
        filters: [],
      };
      if (type === "ten_cong_ty") {
        dataFilter.filters += "ten.vi:regex_i:" + queryString;
      }
      if (type === "giay_phep_kinh_doanh") {
        dataFilter.filters.push(
          "giay_phep_kinh_doanh.so_giay_phep:regex_i:" + queryString
        );
      }
      if (type === "email") {
        dataFilter.filters += "email:regex_i:" + queryString;
      }
      if (type === "so_dien_thoai") {
        dataFilter.filters += "dien_thoai:regex_i:" + queryString;
      }
      console.log(" 459 dataFilter.filters", dataFilter.filters);

      try {
        const response = await mushroom.cong_ty_lu_hanh.listAsync(dataFilter);
        return response.result;
      } catch (error) {
        console.error("Error querySearchCongTyAsync: ", error);
      }
    },
    // Tìm kiếm công ty theo tên
    async querySearchCongTy(queryString, cb) {
      const dataSearch = await this.querySearchCongTyAsync(
        queryString,
        "ten_cong_ty"
      );
      const results = queryString
        ? dataSearch.filter((item) => item.ten.vi.includes(queryString))
        : dataSearch;
      if (results.length > 0) {
        cb(results);
      } else {
        cb([]);
        this.mData.tableRules.dataSearch.value["cong_ty_lu_hanh_id"] =
          queryString;
      }
    },
    handleSelectForSearchCongTy(item) {
      this.mData.tableRules.dataSearch.value["cong_ty_lu_hanh_id"] = item.id;
      this.mData.tenCongTy = item.ten.vi;
    },

    // Tìm kiếm công ty theo số điện thoại
    async querySearchSoDienThoai(queryString, cb) {
      const dataSearch = await this.querySearchCongTyAsync(
        queryString,
        "so_dien_thoai"
      );
      const results = queryString
        ? dataSearch.filter((item) => item.dien_thoai.includes(queryString))
        : dataSearch;
      if (results.length > 0) {
        cb(results);
      } else {
        cb([]);
        this.mData.tableRules.dataSearch.value["cong_ty_lu_hanh_id"] =
          queryString;
      }
    },
    handleSelectForSearchSoDienThoai(item) {
      this.mData.tableRules.dataSearch.value["cong_ty_lu_hanh_id"] = item.id;
      this.mData.soDienThoai = item.dien_thoai;
    },

    // Tìm kiếm công ty theo email
    async querySearchEmail(queryString, cb) {
      const dataSearch = await this.querySearchCongTyAsync(
        queryString,
        "email"
      );
      const results = queryString
        ? dataSearch.filter((item) => item.email.includes(queryString))
        : dataSearch;
      if (results.length > 0) {
        cb(results);
      } else {
        cb([]);
        this.mData.tableRules.dataSearch.value["cong_ty_lu_hanh_id"] =
          queryString;
      }
    },
    handleSelectForSearchEmail(item) {
      this.mData.tableRules.dataSearch.value["cong_ty_lu_hanh_id"] = item.id;
      this.mData.email = item.email;
    },

    // Tìm kiếm công ty theo số giấy phép
    async querySearchSoGiayPhep(queryString, cb) {
      const dataSearch = await this.querySearchCongTyAsync(
        queryString,
        "giay_phep_kinh_doanh"
      );
      console.log("dataSearch: 522", dataSearch);

      const results = queryString
        ? dataSearch.filter((item) =>
            item.giay_phep_kinh_doanh.so_giay_phep.includes(queryString)
          )
        : dataSearch;
      console.log("results: %o", results);

      if (results.length > 0) {
        cb(results);
      } else {
        cb([]);
        this.mData.tableRules.dataSearch.value["cong_ty_lu_hanh_id"] =
          queryString;
      }
    },
    handleSelectForSearchSoGiayPhep(item) {
      this.mData.tableRules.dataSearch.value["cong_ty_lu_hanh_id"] = item.id;
      this.mData.soGiayPhepKinhDoanh = item.giay_phep_kinh_doanh.so_giay_phep;
    },

    clearInputSearch(name) {
      this.mData.tableRules.dataSearch.value[name] = "";
    },
    async getListDanhSachCongTy() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        fields: "id,user_id,chua_duyet,cong_ty_lu_hanh_id,created_time",
      };
      console.log("dataFilter: getListDanhSachCongTyo", dataFilter);

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: this.$route.name,
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch(() => {});
      }
      try {
        const response = await mushroom.dang_ky_chuong_trinh.listAsync(
          dataFilter
        );
        this.mData.tableRules.data = await this.changeData(response.result);
        this.mData.tableRules.total = response.meta.total;
        this.mData.tableRules.page =
          response.meta.offset / response.meta.limit + 1;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      } finally {
        MethodService.stopLadda();
      }
    },
    async changeData(data) {
      const arrayIdCongTy = data.map((item) => item.cong_ty_lu_hanh_id);
      const response = await mushroom.cong_ty_lu_hanh.listAsync({
        fields: "id,ten,giay_phep_kinh_doanh,email,dien_thoai,dia_chi,website",
        filters: ["id:in:" + arrayIdCongTy.join(",")],
      });
      data.forEach((item) => {
        item.ten_cong_ty = "";
        const congTy = response.result.find(
          (congTy) => congTy.id === item.cong_ty_lu_hanh_id
        );

        item.ten_cong_ty = congTy.ten.vi || "Chưa có thông tin";
        item.so_giay_phep_kinh_doanh = congTy.giay_phep_kinh_doanh
          ? congTy.giay_phep_kinh_doanh.so_giay_phep
          : "Chưa có thông tin";
        item.email = congTy.email || "Chưa có thông tin";
        item.dien_thoai =
          congTy.dien_thoai && congTy.dien_thoai.substr(0, 2)
            ? congTy.dien_thoai.replace(/^\d{2}/, "0")
            : "Chưa có thông tin";
        item.website = congTy.website || "Chưa có thông tin";
        item.dia_chi = congTy.dia_chi
          ? congTy.dia_chi.dia_chi
          : "Chưa có thông tin";
        item.created_time = MethodService.formatDate(
          item.created_time,
          "datetime"
        );
      });

      return data;
    },
  },
  async created() {
    this.mData.isApproved =
      this.$route.name === "Admin-DangKyChuongTrinhKichCau-DaDuyet-list";
      this.mData.tableRules.filters += this.$route.name === "Admin-DangKyChuongTrinhKichCau-DaDuyet-list" ? "&chua_duyet=false" : "chua_duyet=true";
    this.fn_hashUrl();
    await this.getListDanhSachCongTy();
  },
};
</script>
